import {SearchSeriesResultDto} from "../models/interfaces/dtos/searchSeriesResult.dto.interface.ts";
import http from "./httpService.ts";
import {AxiosResponse} from "axios";
import {SeriesDto} from "../models/interfaces/dtos/series.dto.interface.ts";
import {IUploadLink} from "../models/interfaces/uploadLink.interface.ts";
import {SeriesInfoDto} from "../models/interfaces/dtos/seriesInfo.dto.interface.ts";
import {SeriesInfo} from "../models/interfaces/series.interface.ts";
import {UserBulkSeriesDto} from "../models/interfaces/dtos/userBulkSeries.dto.interface.ts";
import {ISeriesUploadLink} from "../models/interfaces/seriesUploadLink.interface.ts";
import {SeriesGenresEnum} from "../models/enums/seriesGenres.enum.ts";

export const fetchUserSeries = async (): Promise<UserBulkSeriesDto[]> => {
  try {
    const response: AxiosResponse = await http.get('/api/v1/series/bulk/info');
    return response.data as UserBulkSeriesDto[];
  } catch (err) {
    console.error("Error fetching user series", err);
    throw err;
  }
}

export const seriesSearch = async (searchTerm: string, offset?: number, limit?: number): Promise<SearchSeriesResultDto[]> => {
  try {
    let query: string = `q=${searchTerm}`;
    if (offset !== undefined) {
      query += `&offset=${offset}`;
    }
    if (limit !== undefined) {
      query += `&limit=${limit}`;
    }
    const response: AxiosResponse = await http.get(`/api/v1/series/search?${query}`);
    return response.data as SearchSeriesResultDto[];
  } catch (err) {
    console.error("Error searching series", err);
    throw err;
  }
}


export const fetchSeries = async (seriesId: string): Promise<SeriesDto> => {
  try {
    const response = await http.get(`/api/v1/series/info/${seriesId}`);
    return response.data as SeriesDto;
  } catch (err) {
    console.error("Error fetching series", err);
    throw err;
  }
}

export const getSeriesReferenceFilesUploadUrls = async (seriesId: string, projectIds: string[]): Promise<ISeriesUploadLink> => {
  try {
    const requestBody: { [ids: string]: string[] } = {
      ids: projectIds
    };
    const response: AxiosResponse = await http.post(`/api/v1/series/files/${seriesId}`, requestBody);
    return response.data as ISeriesUploadLink;
  } catch (err) {
    console.error("Error getting series reference files upload URLs", err);
    throw err;
  }
}

export const updateSeriesInfo = async (seriesId: string, seriesInfo: SeriesInfo): Promise<SeriesDto> => {
  try {
    const genresAsEnums: string[] = seriesInfo.genres.map(
      (genre) =>
        Object.entries(SeriesGenresEnum).find(([, value]) => value === genre)?.[0]
    ).filter((key): key is string => !!key);

    const body = {
      nameTranslations: seriesInfo.nameTranslations,
      characters: seriesInfo.characters,
      genres: genresAsEnums,
      terms: seriesInfo.terms,
    }
    const response: AxiosResponse = await http.put(`/api/v1/series/info/${seriesId}`, body);
    return response.data as SeriesDto;
  } catch (err) {
    console.error("Error updating series info", err);
    throw err;
  }
}